import React from 'react';

const HEADER_CELL_CLASSES =
    'uppercase font-sans font-bold text-left text-secondary py-2.5 px-2 border-b-2 border-solid border-secondary';

export const DividendTableHeader = () => {
    return (
        <thead>
            <tr>
                <th className={HEADER_CELL_CLASSES}>Ex-Tag</th>
                <th className={HEADER_CELL_CLASSES}>Betrag</th>
                <th className={HEADER_CELL_CLASSES}>Art der Dividende</th>
                <th className={HEADER_CELL_CLASSES}>Bezugszeitraum</th>
                <th className={HEADER_CELL_CLASSES}>Hauptversammlung</th>
            </tr>
        </thead>
    );
};
